<template>
  <div class="mt-5">
    <v-row justify-lg="center">
      <v-col cols="5" sm="12" md="6" lg="5">
        <validation-observer v-slot="{ invalid }">
          <h3 align="left" class="pb-3">Oído Derecho:</h3>
          <v-data-table
            dense
            disable-sort
            :headers="headersRightEar"
            :items="listRightAudiometry"
            height="auto"
            no-data-text="Sin resultados disponibles"
            fixed-header
            hide-default-footer
            :items-per-page="listRightAudiometry.length"
          >
            <template v-slot:[`item.decibel`]="{ item }">
              <validation-provider
                v-slot="{ errors }"
                name="Nivel auditivo (Decibeles)"
                rules="numeric|max_value:110"
              >
                <v-text-field
                  v-model.number="item.decibel"
                  hint="valor máximo 110 dB"
                  :disabled="isViewDetailsForm"
                  clearable
                  dense
                  :error-messages="errors"
                  :clear-icon="$cnst.CLEAR_ICON"
                ></v-text-field
              ></validation-provider>
            </template>
          </v-data-table>
          <v-col class="text-right mt-3">
            <v-btn
              color="#59805c"
              @click="addResultRightEar()"
              class="white--text"
              :disabled="isViewDetailsForm || invalid"
            >
              <v-icon color="white">mdi-plus</v-icon>Actualizar gráfica oído
              Derecho</v-btn
            >
          </v-col>
        </validation-observer>
      </v-col>
      <v-col cols="5" sm="12" md="6" lg="5">
        <validation-observer v-slot="{ invalid }">
          <h3 align="left" class="pb-3">Oído Izquierdo:</h3>
          <v-data-table
            :headers="headersLeftEar"
            :items="listLeftAudiometry"
            height="auto"
            dense
            disable-sort
            no-data-text="Sin resultados disponibles"
            fixed-header
            hide-default-footer
            :items-per-page="listLeftAudiometry.length"
          >
            <template v-slot:[`item.decibel`]="{ item }">
              <validation-provider
                v-slot="{ errors }"
                name="Nivel auditivo (Decibeles)"
                rules="numeric|max_value:110"
              >
                <v-text-field
                  v-model.number="item.decibel"
                  hint="valor máximo 110 dB"
                  :disabled="isViewDetailsForm"
                  clearable
                  dense
                  :error-messages="errors"
                  :clear-icon="$cnst.CLEAR_ICON"
                ></v-text-field
              ></validation-provider>
            </template>
          </v-data-table>
          <v-col class="text-right mt-3">
            <v-btn
              color="#59805c"
              @click="addResultLeftEar()"
              class="white--text"
              :disabled="isViewDetailsForm || invalid"
            >
              <v-icon color="white">mdi-plus</v-icon>Actualizar gráfica oído
              izquierdo</v-btn
            >
          </v-col>
        </validation-observer>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="12" ref="graphPhoto">
        <GraphAudiometry :chartOptions="chartOptions" />
      </v-col>
      <v-row justify="center">
        <v-col sm="12" md="6" lg="6" v-if="needRightAmplLabel" align="center">
          <div class="text-subtitle-1">
            <h4>Oído derecho promedio PTA: {{ ptaRight }}</h4>
          </div>
        </v-col>
        <v-col sm="12" md="6" lg="6" v-if="needLeftAmplLabel" align="center">
          <div class="text-subtitle-1">
            <h4>Oído izquierdo promedio PTA: {{ ptaLeft }}</h4>
          </div>
        </v-col>
      </v-row>
    </v-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import GraphAudiometry from "@/app/components/audiometry/common/GraphAudiometry.vue";
export default {
  props: {
    model: Object,
    isViewDetailsForm: Boolean,
    toUpdateTable: Boolean,
    takePictureAudiometry: Boolean,
    rightEar: Object,
    leftEar: Object,
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    GraphAudiometry,
  },
  data() {
    return {
      listLeftAudiometry: [
        {
          decibel: "",
          hertz: 125,
        },
        {
          decibel: "",
          hertz: 250,
        },
        {
          decibel: "",
          hertz: 500,
        },
        {
          decibel: "",
          hertz: 750,
        },
        {
          decibel: "",
          hertz: 1000,
        },
        {
          decibel: "",
          hertz: 1500,
        },
        {
          decibel: "",
          hertz: 2000,
        },
        {
          decibel: "",
          hertz: 3000,
        },
        {
          decibel: "",
          hertz: 4000,
        },
        {
          decibel: "",
          hertz: 6000,
        },
        {
          decibel: "",
          hertz: 8000,
        },
      ],
      listRightAudiometry: [
        {
          decibel: "",
          hertz: 125,
        },
        {
          decibel: "",
          hertz: 250,
        },
        {
          decibel: "",
          hertz: 500,
        },
        {
          decibel: "",
          hertz: 750,
        },
        {
          decibel: "",
          hertz: 1000,
        },
        {
          decibel: "",
          hertz: 1500,
        },
        {
          decibel: "",
          hertz: 2000,
        },
        {
          decibel: "",
          hertz: 3000,
        },
        {
          decibel: "",
          hertz: 4000,
        },
        {
          decibel: "",
          hertz: 6000,
        },
        {
          decibel: "",
          hertz: 8000,
        },
      ],
      isDelete: true,
      headersLeftEar: [
        { text: "Frencuencia (Hertz)", value: "hertz", align: "center" },
        { text: "Nivel auditivo (Decibeles)", value: "decibel" },
      ],
      headersRightEar: [
        { text: "Frencuencia (Hertz)", value: "hertz", align: "center" },
        { text: "Nivel auditivo (Decibeles)", value: "decibel" },
      ],
      listBodyParts: [],
      chartOptions: {
        chart: {
          height: "30%",
        },
        title: {
          text: " A U D I O G R A M A",
        },
        credits: {
          enabled: false,
        },
        exporting: { enabled: false },
        yAxis: {
          lineWidth: 2,
          resize: {
            enabled: true,
          },
          gridLineWidth: 1,
          reversed: true,
          title: {
            text: "Nivel auditivo (dB HL)",
          },
          tickPositions: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110],
          plotLines: [
            {
              value: 0,
              width: 2,
              color: "#000000",
            },
          ],
          plotBands: [
            {
              from: 80,
              to: 110,
              color: "rgba(176,170,168,255)",
              label: {
                align: "center",
                text: "PROFUNDA",
                style: {
                  color: "#FFFFFF",
                },
              },
            },
            {
              from: 60,
              to: 80,
              color: "rgba(177,182,200,255)",
              label: {
                align: "center",
                text: "GRAVE",
                style: {
                  color: "#FFFFFF",
                },
              },
            },
            {
              from: 40,
              to: 60,
              color: "rgba(204,207,210,255)",
              label: {
                align: "center",
                text: "MODERADA",
                style: {
                  color: "#FFFFFF",
                },
              },
            },
            {
              from: 20,
              to: 40,
              color: "rgba(242,241,243,255)",
              label: {
                align: "center",
                text: "LEVE",
                style: {
                  color: "#00000",
                },
              },
            },
            {
              from: 0,
              to: 20,
              color: "rgba(255,255,255,255)",
              label: {
                align: "center",
                text: "NORMAL",
                style: {
                  color: "#000000",
                },
              },
            },
          ],
        },
        xAxis: {
          gridLineWidth: 1,
          opposite: true,
          title: {
            text: "Frencuencia (Hz)",
          },
          // tickPositions: [
          //   125,
          //   250,
          //   500,
          //   750,
          //   1000,
          //   1500,
          //   2000,
          //   3000,
          //   4000,
          //   6000,
          //   8000,
          // ],
          labels: {
            formatter: function() {
              return this.value;
            },
            overflow: "justify",
          },
          plotLines: [
            {
              value: 0,
              width: 2,
              color: "#000000",
            },
          ],
        },
        plotOptions: {
          series: {
            connectNulls: true,
          },
          line: {
            dataLabels: {
              enabled: true,
            },
          },
          scatter: {
            marker: {
              radius: 5,
              symbol: "circle",
              fillColor: "#008CBA",
              lineColor: "#333333",
              lineWidth: 1,
            },
            states: {
              hover: {
                enabled: true,
                lineColor: "rgb(100,100,100)",
              },
            },
            tooltip: {
              headerFormat: "<b>{series.name}</b><br>",
              pointFormat:
                "Frecuencia: {point.x} Hz<br>Nivel auditívo: {point.y} dB HL",
            },
          },
        },
        series: [
          {
            name: "Oído derecho",
            color: "rgba(255, 18, 5)",
            data: [],
          },
          {
            name: "Oído izquierdo",
            color: "rgba(5, 193, 255)",
            data: [],
          },
        ],
      },
      audiometryGraphImage: "",
      clearLeftList: [],
      clearRightList: [],
      ptaRight: "",
      ptaLeft: "",
      needRightAmplLabel: false,
      needLeftAmplLabel: false,
    };
  },
  created() {
    if (this.toUpdateTable) {
      this.checksaveResults();
    }
  },
  watch: {
    takePictureAudiometry: function() {
      if (this.takePictureAudiometry) {
        this.obtainGraphImage();
        this.updateDataToModel();
      }
    },
  },
  methods: {
    addResultRightEar() {
      this.clearRightList = [];
      this.chartOptions.series[0].data = [];
      let flag = false;
      for (let deci in this.listRightAudiometry) {
        if (this.listRightAudiometry[deci].decibel !== "") {
          flag = true;
        }
      }
      if (flag) {
        this.chartOptions.series[0].data = this.listRightAudiometry.map(
          (value) => [parseInt(value.hertz), parseInt(value.decibel)]
        );
        let listRightToModel = this.listRightAudiometry.map((result) => {
          if (result.decibel != "") {
            return {
              bodyPart: this.rightEar,
              hertz: result.hertz,
              decibel: result.decibel,
            };
          }
        });
        this.clearRightList = listRightToModel.filter(Boolean);
        this.calculatePTA("right");
      } else {
        this.$utilFront.notifications(
          "los datos de la gráfica (oído derecho) están vacíos",
          "WARNING"
        );
      }
    },
    addResultLeftEar() {
      this.clearLeftList = [];
      this.chartOptions.series[1].data = [];
      let flag = false;
      for (let deci in this.listLeftAudiometry) {
        if (this.listLeftAudiometry[deci].decibel !== "") {
          flag = true;
        }
      }
      if (flag) {
        this.chartOptions.series[1].data = this.listLeftAudiometry.map(
          (value) => [parseInt(value.hertz), parseInt(value.decibel)]
        );
        let listLeftToModel = this.listLeftAudiometry.map((result) => {
          if (result.decibel !== "" && result.decibel !== null) {
            return {
              bodyPart: this.leftEar,
              hertz: result.hertz,
              decibel: result.decibel,
            };
          }
        });
        this.clearLeftList = listLeftToModel.filter(Boolean);
        this.calculatePTA("left");
      } else {
        this.$utilFront.notifications(
          "los datos de la gráfica (oído izquierdo) están vacíos",
          "WARNING"
        );
      }
    },
    updateDataToModel() {
      let clearList = this.clearLeftList.concat(this.clearRightList);
      this.model.resultsTest = clearList.filter(function(result) {
        return result.decibel !== null;
      });
    },
    calculatePTA(side) {
      const list = side === "left" ? this.clearLeftList : this.clearRightList;
      const freqs = [500, 1000, 2000, 4000];
      const matchingElems = list.filter((elem) => freqs.includes(elem.hertz));

      const sum = matchingElems.reduce((acc, elem) => acc + elem.decibel, 0);
      const numElems = matchingElems.length;

      const pta = numElems === 0 ? "" : sum / numElems;
      if (pta > 0) {
        if (side === "left") {
          this.needLeftAmplLabel = true;
          this.ptaLeft = pta;
        } else {
          this.needRightAmplLabel = true;
          this.ptaRight = pta;
        }
      } else {
        if (side === "left") {
          this.needLeftAmplLabel = false;
          this.ptaLeft = "";
        } else {
          this.needRightAmplLabel = false;
          this.ptaRight = "";
        }
      }
    },
    // calculatePTA(side) {
    //   switch (side) {
    //     case "left":
    //       let sumaLeft = 0;
    //       let numElems = 0;
    //       for (let o in this.clearLeftList) {
    //         if (
    //           this.clearLeftList[o].hertz === 500 ||
    //           this.clearLeftList[o].hertz === 1000 ||
    //           this.clearLeftList[o].hertz === 2000 ||
    //           this.clearLeftList[o].hertz === 4000
    //         ) {
    //           sumaLeft += this.clearLeftList[o].decibel;
    //           numElems++;
    //         }
    //       }
    //       if (numElems == 0) {
    //         this.ptaLeft = "";
    //       } else {
    //         this.ptaLeft = sumaLeft / numElems;
    //       }
    //       if (this.ptaLeft) {
    //         this.needLeftAmplLabel = true;
    //       } else {
    //         this.needLeftAmplLabel = false;
    //       }
    //       break;
    //     case "right":
    //       let sumaRight = 0;
    //       let numElemsRight = 0;
    //       for (let o in this.clearRightList) {
    //         if (
    //           this.clearRightList[o].hertz === 500 ||
    //           this.clearRightList[o].hertz === 1000 ||
    //           this.clearRightList[o].hertz === 2000 ||
    //           this.clearRightList[o].hertz === 4000
    //         ) {
    //           sumaRight += this.clearRightList[o].decibel;
    //           numElemsRight++;
    //         }
    //       }
    //       if (numElemsRight == 0) {
    //         this.ptaRight = "";
    //       } else {
    //         this.ptaRight = sumaRight / numElemsRight;
    //       }
    //       if (this.ptaRight) {
    //         this.needRightAmplLabel = true;
    //       } else {
    //         this.needRightAmplLabel = false;
    //       }
    //       break;
    //   }
    // },

    // checksaveResults() {
    //   this.listResultAudiometry = this.model.resultsTest;
    //   if (this.model.resultsTest.length > 0) {
    //     this.model.resultsTest.map((result) => {
    //       switch (result.bodyPart.idBodyPart) {
    //         case 5:
    //           for (let o in this.listLeftAudiometry) {
    //             if (this.listLeftAudiometry[o].hertz == result.hertz) {
    //               this.listLeftAudiometry[o].decibel = result.decibel;
    //             }
    //           }
    //           break;
    //         case 4:
    //           for (let o in this.listRightAudiometry) {
    //             if (this.listRightAudiometry[o].hertz == result.hertz) {
    //               this.listRightAudiometry[o].decibel = result.decibel;
    //             }
    //           }
    //           break;
    //       }
    //     });
    //     this.addResultLeftEar();
    //     this.addResultRightEar();
    //   }
    // },
    checksaveResults() {
      const leftAudiometrySet = new Set(
        this.listLeftAudiometry.map((audiometry) => audiometry.hertz)
      );
      const rightAudiometrySet = new Set(
        this.listRightAudiometry.map((audiometry) => audiometry.hertz)
      );
      this.model.resultsTest.forEach(({ bodyPart, hertz, decibel }) => {
        if (bodyPart.idBodyPart === 5 && leftAudiometrySet.has(hertz)) {
          this.listLeftAudiometry.find(
            (audiometry) => audiometry.hertz === hertz
          ).decibel = decibel;
        } else if (bodyPart.idBodyPart === 4 && rightAudiometrySet.has(hertz)) {
          this.listRightAudiometry.find(
            (audiometry) => audiometry.hertz === hertz
          ).decibel = decibel;
        }
      });
      this.addResultLeftEar();
      this.addResultRightEar();
    },
    obtainGraphImage() {
      var domtoimage = require("dom-to-image");
      const node = this.$refs.graphPhoto;
      domtoimage.toPng(node).then((dataUrl) => {
        var img = new Image();
        img.src = dataUrl;
        this.audiometryGraphImage = img.src;
        this.model.audiometryGraphImage = this.audiometryGraphImage;
      });
    },
    setEarGraph(left, right) {
      this.chartOptions.series[0].data = right;
      this.chartOptions.series[1].data = left;
    },
  },
};
</script>

<style></style>
